import React, { ReactNode } from 'react';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import LegacyFooter from '../../legacy/root/Footer';
import { Banners } from '../../@mrkt/features/Banner/Banners';
import { NavBar } from './Nav/NavBar';
import { USE_FRODOR_FOOTER } from './Nav/constants';
import { getLinkStyle } from '../ui';
import { darkTheme } from '../Theme';
import { Footer } from './Footer';
import { Main } from './Main';
import { useRouteBanners } from './useRouteBanners';
import { useLayoutContext } from './LayoutState';
import { PreviewLink } from './PreviewLink';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.layout.background};
  color: ${({ theme }) => theme.layout.text};
`;

type LayoutProps = {
  children: ReactNode;
};

const FooterComponent = (USE_FRODOR_FOOTER && Footer) || LegacyFooter;

// terrible hack to override some bootstrap *&^# for now
const UndoLegacyStyles = createGlobalStyle`
  .footer-default .nav a {
    ${props => getLinkStyle(props)}
  }
`;

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { showNavBar, showFooter, isPreview } = useLayoutContext();

  useRouteBanners();

  return (
    <ThemeProvider theme={darkTheme}>
      <LayoutContainer>
        {showNavBar && <NavBar />}
        <Banners />
        <Main>{children}</Main>
        {showFooter && <FooterComponent />}
        {isPreview && process.browser && <PreviewLink />}
      </LayoutContainer>
      <UndoLegacyStyles />
    </ThemeProvider>
  );
};
